export const billingKeys = {
  subscription: () => ['subscription'],
  invoices: () => ['invoices'],
  cards: (params: { limit?: number }) => ['cards', params],
};
